import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  systemRequest,
  systemFailure,
  systemSuccess,
} from '../reducers/system';
import { API_LINK } from '../../constants';



const API = `${API_LINK}api/checkMaintenance`

function* systemAxios() {
  const state = yield select(fullState => fullState);
  const response = yield call(() =>
    axios({
      method: 'get',
      url: `${API}?platform=web`,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
    }),
  );
  
  return response;
}

function* workerSystemSaga() {
  try {
    const response = yield call(systemAxios);
    if (response.status === 200) {
      
      yield put(systemSuccess(response.data));
    }
    if (response.status === 400) {
      yield put(systemFailure('Content does not exist'));
    }
  } catch (error) {
    
    yield put(systemFailure(error));
  }
}

export function* watcherSystemSaga() {
  yield takeLatest(systemRequest().type, workerSystemSaga);
}
